import React, {Component} from 'react';

import LogoPic from "../../assets/images/logo.png";
import Toast from '../Common/Toast';
import API from '../../services/API';
import {toast} from "react-toastify";
import Slideshow from "../Common/Slideshow";
import LogoGohar from "../../assets/images/goharzaminLogo.png";

class Register extends Component {
    state = {
        buttonStatus:  "disabled",
        buttonText : "ثبت و ورود به سامانه",
        loading: "d-none",
        isCompany: 1,
        companyName :  "",
        isCompanyChecked: 1,
        firstName: "",
        lastName: "",

    }
    onInputChange = (event) => {
        if (event.target.name ==='lastName' && event.target.value.length > 2) {
            this.setState({buttonStatus: ""})
        } else {
            this.setState({buttonStatus: "disabled"})
        }
        this.setState({[event.target.name]: event.target.value});
    }

    onClickLabel = (val) => {
        this.setState({isCompanyChecked:val , isCompany: val})
    }
    onButtonClick = () => {
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });


        const request = {
            title: this.state.companyName,
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            save_user_info: this.state.isCompanyChecked,
            phone_specification: navigator.userAgent,
        }
        if(this.state.isCompanyChecked === 1) {
            API.storeCompany(request)
                .then((response) => {
                        toast.success(response.user_message);
                        setTimeout (() => {
                            this.props.history.push("/profile/company");
                        },1500)
                })
                .catch((error) => {
                    const buttonText  = "ثبت و ورود به سامانه";
                    const  loading = "d-none";
                    const buttonStatus = "";
                    this.setState({buttonText,loading,buttonStatus });
                    toast.error(error.response.data.user_message);
                });
        }
        else {
            const formData = new FormData();
            formData.append('last_name' , this.state.lastName);
            formData.append('first_name' ,  this.state.firstName);
            formData.append('phone_specification' , navigator.userAgent);
            API.updateProfile(formData)
                .then((response) => {

                    toast.success(response.user_message);
                    setTimeout (() => {
                         this.props.history.push("/profile");
                    },1500)
                })
                .catch((error) => {
                    toast.error(error.response.data.user_message);
                });
        }


    }
    render() {
        return (
            <React.Fragment>
                <Toast  />
                <section className="container-fluid ">
                    <div className="row">
                        <div className="col-md-5 pt-2 ">
                            <div className="card border-1 rounded-more vh100">
                                <div className="col-12 pt-2">
                                    {
                                        window.localStorage.getItem("sysTitle").indexOf('زمین') < 0 ?
                                            <img src={LogoPic} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " /> :
                                            <img src={LogoGohar} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " width='200' />
                                    }
                                </div>
                                <h3 className="col-12 text-center mt-5 mb-3 header-text">
                                   ثبت نام در سامانه
                                </h3>
                                <hr className="w-50 m-auto my-3 text-secondary"/>
                                <div className="mt-5 px-5 rtl text-center">
                                    <div className="form-check form-check-inline">
                                        <label className="form-check-label small"
                                               htmlFor="inlineRadio1"
                                               onClick={()=>this.onClickLabel(1)}
                                        >ثبت نام به عنوان شرکت</label>
                                        <input className="form-check-input"
                                               type="radio"
                                               name="isCompany"
                                               value="1"
                                               checked={this.state.isCompanyChecked}
                                                onChange={this.onInputChange}
                                        />

                                    </div>
                                    <div className="form-check form-check-inline ">
                                        <label className="form-check-label small"
                                               htmlFor="inlineRadio2"
                                               onClick={()=>this.onClickLabel(0)}
                                        >ثبت نام به عنوان شخص</label>
                                        <input className="form-check-input"
                                               type="radio"
                                               name="isCompany"
                                               value="0"
                                               checked={!this.state.isCompanyChecked}
                                               onChange={this.onInputChange}
                                        />

                                    </div>
                                </div>
                                {this.state.isCompany === 1 &&
                                <div className="mt-5 px-5">
                                    <input type="text" autoFocus value={this.state.companyName}
                                           onChange={this.onInputChange}
                                           required
                                           name='companyName'
                                           className="form-control  text-center rounded-more"
                                           aria-describedby="passwordHelpBlock" placeholder="نام شرکت"/>

                                </div>
                                }
                                <div className="mt-3 px-5">
                                    <input type="text"  value={this.state.firstName}
                                           onChange={this.onInputChange}
                                           name='firstName'
                                           className="form-control text-center rounded-more"
                                           aria-describedby="passwordHelpBlock" placeholder="نام "/>


                                </div>
                                <div className="mt-3 px-5">
                                    <input type="text"
                                           value={this.state.lastName}
                                           onChange={this.onInputChange}
                                           required
                                           name='lastName'
                                           className="form-control text-center rounded-more"
                                           aria-describedby="passwordHelpBlock" placeholder="نام خانوادگی"/>

                                </div>
                                <div className="mt-5 px-5">
                                    <button onClick={this.onButtonClick} disabled={this.state.buttonStatus} type="submit"
                                            className="btn btn-primary w-100 py-2">
                                        {this.state.buttonText}
                                        <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                               aria-hidden="true"></span>
                                    </button>
                                </div>

                            </div>
                        </div>

                        <div className="col-md-7 ">
                            <Slideshow />
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
    componentDidMount =()  =>{

    }


}

export default Register;